<template>
  <div class="component-wrapper secondary d-flex flex-column">
    <div class="d-flex px-2">
      <v-btn icon @click="$router.push('/routes')">
        <v-icon color="white" size="17">mdi-arrow-left</v-icon>
      </v-btn>
      <!-- <h1 class="white--text font-weight-bold text-h5">Routes</h1> -->
    </div>

    <div
      class="d-flex align-center px-4 mb-4"
      @click="showFilters = !showFilters"
    >
      <v-icon color="white" class="mr-2">mdi-tune-vertical</v-icon>
      <span class="body-1 white--text">{{ $t("general.filters_label") }}</span>
    </div>

    <div v-if="showFilters" class="d-flex flex-column pa-2 mb-4 align-center">
      <v-select
        @change="filterApply"
        :items="categories"
        :label="$t('general.categories_label')"
        item-text="name"
        item-value="id"
        v-model="filters.category"
        color="white"
        dark
        hide-details
        style="width: 350px"
        class="mb-2"
      >
      </v-select>

      <v-select
        @change="filterApply"
        :items="islands"
        v-model="filters.island"
        :label="$t('general.islands_label')"
        item-text="name"
        item-value="id"
        color="white"
        dark
        hide-details
        style="width: 350px"
      >
      </v-select>
    </div>

    <div
      v-if="loader"
      class="d-flex flex-column align-center flex-grow-1"
      style="height: 500px"
    >
      <v-progress-circular indeterminate color="white" size="60">
      </v-progress-circular>
    </div>

    <div
      v-else-if="!loader && routes.length > 0"
      v-for="(route, i) in routes"
      :key="i"
      class="d-flex flex-column px-4"
      style="width: 100%"
    >
      <div
        @click="$router.push(`${$route.path}/${route.id}`)"
        class="d-flex justify-start align-center white--text route font-weight-thin body-1 mb-2"
      >
        <span class="mr-auto">{{ route.name }}</span>
        <v-btn icon color="white">
          <v-icon> mdi-arrow-right</v-icon>
        </v-btn>
      </div>

      <v-divider
        v-if="i != routes.length - 1"
        class="mb-2"
        style="width: 100% !important"
        color="white"
      ></v-divider>
    </div>

    <span class="px-4 white--text body-1 font-weight-thin" v-else
      >No data available</span
    >
  </div>
</template>

<script>
import axios from "axios";
import { mapMutations } from "vuex";
export default {
  async created() {
    try {
      const categories = await axios.get(
        `${process.env.VUE_APP_BASE_URL}/path-categories`
      );
      const areas = await axios.get(`${process.env.VUE_APP_BASE_URL}/areas`);

      const paths = await axios.get(`${process.env.VUE_APP_BASE_URL}/paths`, {
        params: {
          area: this.filters.island,
          category: this.filters.category != 15 ? this.filters.category : null,
        },
      });

      const sortedAreas = areas.data.areas.sort((a, b) => {
        return a.weight - b.weight;
      });

      this.categories = categories.data;

      this.routes = paths.data;

      this.islands = sortedAreas;

      this.loader = false;
    } catch (e) {
      this.loader = false;
      console.log(e);
    }
  },

  data() {
    return {
      islands: null,
      showFilters: false,
      categoriesExpanded: false,
      loader: true,
      routes: [],
      categories: [],
    };
  },

  computed: {
    filters: {
      get() {
        return this.$store.state.base.filters;
      },
      set(newValue) {
        this.setFilters(newValue);
      },
    },
  },

  methods: {
    ...mapMutations(["setFilters"]),
    changeRadio(category) {
      this.selectedCategory = category;
    },

    async filterApply() {
      try {
        this.loader = true;

        this.routes = [];
        const res = await axios.get(`${process.env.VUE_APP_BASE_URL}/paths`, {
          params: {
            area: this.filters.island,
            category:
              this.filters.category != 15 ? this.filters.category : null,
          },
        });
        this.routes = res.data;
        this.loader = false;
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>

<style scoped lang="scss">
</style>